module.exports = __webpack_public_path__ + "img/level_five_hover.cbf9022a.png";